import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "main_div" }
const _hoisted_2 = { style: {"margin-top":"20px","text-align":"center","vertical-align":"middle"} }
const _hoisted_3 = { class: "gsi-material-button-content-wrapper" }
const _hoisted_4 = { class: "gsi-material-button-icon" }
const _hoisted_5 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  style: {"display":"block"}
}

import { ref, onMounted, watch } from "vue"; // watch 임포트 추가
import {
  NSpace,
  NCard,
  NDataTable,
  NButton,
  NModal,
  NDescriptions,
  NDescriptionsItem,
  NForm,
  NFormItem,
  NInput,
  NInputGroup,
  FormInst,
  FormRules,
  NIcon,
  NSpin,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui";
import { useRouter } from "vue-router";
import Loading from "@/components/Loading.vue";
import { useAuth } from "@/composables/useAuth";
import { USER_ROUTES } from "@/assets/route_constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const { loading, isLoggedIn, loggedInUserId, signInWithGoogle, handleLogout } =
  useAuth();
const router = useRouter();

watch(
  isLoggedIn,
  (newValue) => {
    if (newValue === true) {
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true } // 컴포넌트가 마운트될 때 즉시 실행하여 초기 로그인 상태를 확인합니다.
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, _unref(loading)]
    ]),
    _withDirectives(_createVNode(_unref(NCard), { class: "content_div" }, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "login_title" }, "CreateX Management System", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "delimiter_line" }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "gsi-material-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(signInWithGoogle) && _unref(signInWithGoogle)(...args)))
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "gsi-material-button-state" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[1] || (_cache[1] = [
                  _createElementVNode("path", {
                    fill: "#EA4335",
                    d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                  }, null, -1),
                  _createElementVNode("path", {
                    fill: "#4285F4",
                    d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                  }, null, -1),
                  _createElementVNode("path", {
                    fill: "#FBBC05",
                    d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                  }, null, -1),
                  _createElementVNode("path", {
                    fill: "#34A853",
                    d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                  }, null, -1),
                  _createElementVNode("path", {
                    fill: "none",
                    d: "M0 0h48v48H0z"
                  }, null, -1)
                ])))
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "gsi-material-button-contents" }, "Sign in with Google", -1))
            ])
          ])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "delimiter_line" }, null, -1))
      ]),
      _: 1
    }, 512), [
      [_vShow, _unref(loading) == false]
    ])
  ]))
}
}

})